import config from '@/config'
import axios from 'axios'
import { store } from '@/store/store'
import router from '@/router'
import moment from 'moment'

export default {
  authDefault: function(creds, callback) {
    let url = 'adminlogin'
    if (creds.userid == 'zwizadmin') {
      url += `?limit=100&offset=${creds.offset}`
      if (creds.pagename) url += `&pagename=${creds.pagename}`
    }
    axios
      .post(config.serverUrl + url, {
        userid: creds.userid,
        password: creds.password,
        'g-recaptcha-response': creds['g-recaptcha-response']
      })
      .then(response => {
        response = response.data
        if (response.responsecode === 200) {
          callback(null, response)
        } else if (response.responsecode === 400) {
          let message = response.reason ? response.reason : 'Something went wrong, please try again'
          store
            .dispatch('logout', {
              error: { code: response.responsecode, message: message }
            })
            .then(function() {
              router.push('/' + store.getters.currentLang + '/nigol')
            })

          // router.push('/nigol')
          callback(new Error(message))
        } else {
          if (response.reason) {
            callback(new Error(response.reason))
          } else {
          }
        }
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  authLogout(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'logout', {})
      .then(response => {
        callback()
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getLongLiveToken: function(creds, callback) {
    axios
      .post(config.serverUrl + 'getlonglivetoken', {
        appid: config.appid,
        accesstoken: creds.accessToken
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getPageList: function(data, callback) {
    axios
      .get(
        'https://graph.facebook.com/v3.1/me/accounts?access_token=' +
          data.token +
          '&limit=1000&fields=access_token,category,category_list,id,tasks,name,name_with_location_descriptor'
      )
      .then(response => {
        // JSON responses are automatically parsed.
        var response = response.data
        if (response.data) {
          let pagelist = []
          $.each(response.data, function(index, value) {
            var page = Object.assign({}, value)
            page.name = page.name_with_location_descriptor

            if (value.perms) {
              if (
                value.perms.indexOf('ADMINISTER') > -1 ||
                value.perms.indexOf('EDIT_PROFILE') > -1
              ) {
                pagelist.push(page)
              }
            }
            if (value.tasks) {
              if (
                value.tasks.indexOf('MANAGE') > -1 ||
                value.tasks.indexOf('CREATE_CONTENT') > -1
              ) {
                pagelist.push(page)
              }
            }
          })
          callback(null, pagelist)
        } else {
          callback(new Error(response.reason))
        }
      })
      .catch(e => {
        callback(new Error('session expire. Please login again.'))
      })
  },

  getBotList: function(data, token, callback) {
    axios.defaults.headers.common = {
      authorization: token
    }
    axios
      .post(config.serverUrl + 'checkbotlist', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getAllPublicTheme: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'getallpublictheme?appid=' + data.appid)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getProducts: function(data, callback) {
    let url = config.serverUrl + 'products'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getCategories: function(data, callback) {
    let url = config.serverUrl + 'categories'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  saveProduct: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'products', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  editProduct: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'products?id=' + data.id, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  deleteProduct: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .delete(config.serverUrl + 'products?id=' + data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getSignedRequest: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = config.serverUrl + 'sign-s3-v2?file-name=' + data.name + '&file-type=' + data.type

    axios
      .get(url)
      .then(response => {
        // JSON responses are automatically parsed.
        var response = response.data
        response.file = data.file
        this.uploadfile(response, function() {
          callback(null, response.url)
        })
      })
      .catch(e => {
        callback(new Error('session expire. Please login again.'))
      })
  },

  uploadfile: function(data, callback) {
    let signedRequest = data.signedRequest
    const formData = new FormData()
    formData.append('acl', 'public-read')
    Object.keys(signedRequest.fields).forEach(key => {
      formData.append(key, signedRequest.fields[key])
    })

    // Actual file has to be appended last.
    formData.append('file', data.file)

    const xhr = new XMLHttpRequest()
    xhr.open('POST', signedRequest.url, true)
    xhr.send(formData)
    xhr.onload = function() {
      if (xhr.readyState === 4) {
        // alert(xhr.status);
        if (xhr.status === 200 || xhr.status === 204) {
          callback()
        } else {
          alert('Could not upload file.')
        }
      }
    }
  },
  saveCategory: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'categories', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  editCategory: function(data, callback) {
    let request = {
      name: data.name
    }
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'categories?id=' + data.id, request)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  deleteCategory: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .delete(config.serverUrl + 'categories?id=' + data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  saveSubCategory: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'subcategories', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  deleteSubCategory: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .delete(config.serverUrl + 'subcategories?id=' + data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  editSubCategory: function(data, callback) {
    let request = {
      name: data.name
    }
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'subcategories?id=' + data.id, request)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getProductStock: function(productid, callback) {
    let url = config.serverUrl + 'productstock?productid=' + productid

    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  saveProductStock: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'productstock?productid=' + data.productid, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  editProductStock: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'productstock?productstockid=' + data.id, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  deleteProductStock: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .delete(config.serverUrl + 'productstock?productstockid=' + data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  newSubscribe: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'newsubscribe', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  unSubscribe: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'unsubscribe', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getAllUsers: function(data, callback) {
    let url = config.serverUrl + 'getallusers?pageid=' + data['pageid']
    if (data.offset) {
      url += '&offset=' + data['offset']
    }
    if (data.limit) {
      url += '&limit=' + data['limit']
    }
    if (data['grouptype'] && data['grouptype'] != '') {
      url += '&grouptype=' + data['grouptype']
    }
    if (data['filter']) {
      // console.log(data.filter)
      url += '&' + this.joinFilter(data['filter'], store.getters.getPackage == 'premium')
    }
    // if (store.getters.getPackage == 'premium') {
    //   url += '&context'
    // }
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  multicast: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'multicast', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  toggleBotStatus: function(data, callback) {
    let url = !data.status ? 'stopbot' : 'startbot'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  checkBotlist: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'checkbotlist', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  saveWelcomeMessage: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'botwelcomemessage', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getWelcomeMessage: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'botwelcomemessage?pageid=' + data['pageid'])
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getLiveChatUsers: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'getuserthread', { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getUserMessages: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(
        config.serverUrl +
          'getchatlog?userid=' +
          data['userid'] +
          '&limit=' +
          data['limit'] +
          '&offset=' +
          data['offset'] +
          '&pageid=' +
          data['pageid']
      )
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  sendMessage: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'sendmessage', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  endSessionChat: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'endconversation', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  openSessionChat: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'startconversation', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getIntent: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'intents?pageid=' + data['pageid'])
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  addIntent: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'intents', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  editIntent: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'intents?id=' + data['id'], data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  deleteIntent: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .delete(config.serverUrl + 'intents', { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getDashboardSummary: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    var url =
      config.serverUrl +
      'pagereport_summary?pageid=' +
      data['pageid'] +
      '&datefrom=' +
      data['datefrom'] +
      '&dateto=' +
      data['dateto']
    if (data.app != 'all') {
      url += '&app=' + data.app
    }
    axios
      .get(url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getDashboardIntent: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    var url =
      config.serverUrl +
      'pagereport_intents?pageid=' +
      data['pageid'] +
      '&datefrom=' +
      data['datefrom'] +
      '&dateto=' +
      data['dateto']
    if (data.app != 'all') {
      url += '&app=' + data.app
    }
    if (data.group) {
      url += '&intentgroup=' + data.group
    }
    axios
      .get(url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getDashboardActiveUserByDate: function(data, callback) {
    var url =
      config.serverUrl +
      'pagereport_activeusers_bydate?pageid=' +
      data['pageid'] +
      '&datefrom=' +
      data['datefrom'] +
      '&dateto=' +
      data['dateto']
    if (data.app != 'all') {
      url += '&app=' + data.app
    }
    axios
      .get(url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getDashboardActiveUserByTime: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    var url =
      config.serverUrl +
      'pagereport_activeusers_bytime?pageid=' +
      data['pageid'] +
      '&datefrom=' +
      data['datefrom'] +
      '&dateto=' +
      data['dateto'] +
      '&time_0=' +
      data['time_0'] +
      '&time_1=' +
      data['time_1']
    if (data.app != 'all') {
      url += '&app=' + data.app
    }
    axios
      .get(url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getOrderSummary: function(data, callback) {
    var url = config.serverUrl + `ordersummary?`
    if (data.pageid && data.pageid != '' && data.pageid != null) {
      url += 'pageid=' + data['pageid']
      axios.defaults.headers.common = {
        AUTHORIZATION: store.getters.securityToken
      }
    } else if (data.lineid && data.lineid != '' && data.lineid != null) {
      url += 'lineid=' + data['lineid']
    }
    url +=
      '&datefrom=' + data['datefrom'] + '&dateto=' + data['dateto'] + '&status=' + data['status']

    axios
      .get(url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  editOrderSummary: function(data, callback) {
    var url = config.serverUrl + 'ordersummary?'
    if (data.lineid && data.lineid != '' && data.lineid != null) {
      url += 'lineid=' + data['lineid'] + '&pageid=' + data['pageid']
    } else if (data.pageid && data.pageid != '' && data.pageid != null) {
      axios.defaults.headers.common = {
        AUTHORIZATION: store.getters.securityToken
      }
      url += 'pageid=' + data['pageid']
    }
    url += '&id=' + data.id
    axios
      .put(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getShopProfile: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'shopprofile?pageid=' + data['pageid'])
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  editShopProfile: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'shopprofile?pageid=' + data.pageid, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getLineNotifySubscriber: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'notifyadminuser?pageid=' + data['pageid'])
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  deleteLineNotifySubscriber: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(
        config.serverUrl +
          'notifyadminuser_remove?pageid=' +
          data['pageid'] +
          '&userid=' +
          data['userid'],
        data
      )
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  sendMessageLine: function(data, callback) {
    axios
      .post(config.serverUrl + 'sendmessageline', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getChatlogLine: function(data, callback) {
    axios
      .get(
        config.serverUrl +
          'getchatlog?userid=' +
          data['userid'] +
          '&adminid=' +
          data['adminid'] +
          '&pageid=' +
          data['pageid'] +
          '&limit=' +
          data['limit'] +
          '&offset=' +
          data['offset']
      )
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getChatUsersLine: function(data, callback) {
    // axios.defaults.headers.common = {
    // 	'AUTHORIZATION': store.getters.securityToken
    // };
    axios
      .get(
        config.serverUrl +
          'getuserthread?pageid=' +
          data['pageid'] +
          '&app=' +
          data['app'] +
          '&inbox=' +
          data['type'] +
          '&limit=' +
          data['limit'] +
          '&offset=' +
          data['offset']
      )
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getPaypalUrl: function(data, callback) {
    axios
      .get(config.serverUrl + 'getpaypal_registerurl')
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getPaypalTrackingStatus: function(data, callback) {
    axios
      .get(config.serverUrl + 'getpaypal_trackingstatus?tracking_id=' + data['tracking_id'])
      .then(response => {
        // this.defaultResponse(response, callback)
        callback(null, response.data)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  updatePaypalMerchantId: function(data, callback) {
    // paypal_merchantid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'updatepaypal_merchantid?pageid=' + data['pageid'], data)
      .then(response => {
        callback(null, response.data)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getSetting: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'getallcontent?pageid=' + data['pageid'])
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getBotDetail: function(data, callback) {
    // console.log(store.getters.securityToken)
    if (!data['pageid']) {
      return false
    }
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'checkbotpage?pageid=' + data['pageid'])
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getPersistentMenu: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }

    axios
      .post(config.serverUrl + 'getmessenger_profile', {
        pageid: data['pageid'],
        status: data['status'],
        fields: 'persistent_menu',
        access_token: data['access_token']
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  editPersistentMenu: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    var url = config.serverUrl + 'messenger_profile'
    axios
      .post(url, { ...data, fields: 'persistent_menu' })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getTraningConversation: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(
        config.serverUrl +
          'defaultchatlogs?pageid=' +
          data.pageid +
          '&intentname=' +
          data.intentname +
          '&datefrom=' +
          data.datefrom +
          '&dateto=' +
          data.dateto
      )
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  updateTrainingConversation: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'updatedefaultchatlogs', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  updateConfig: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'updateadminconfig', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getBroadcast: function(pageid, callback) {
    let url = config.serverUrl + 'getbroadcast?pageid=' + pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  estimateReach: function(data, callback) {
    let url = config.serverUrl + 'estimatereach?pageid=' + data.pageid
    if (data['filter'] && store.getters.getPackage == 'premium') {
      url += '&' + this.joinFilter(data['filter'], true)
    } else if (data['condition']) {
      url += data['condition']
    }
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  updateBroadcast: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    if (data['filter']) {
      var filter = ''
      filter += this.joinFilter(data['filter'], true)
      data.m_condition = filter
    }
    axios
      .post(config.serverUrl + 'savebroadcast', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  deleteBroadcast: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .delete(config.serverUrl + 'deletebroadcast', { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getTutoriallist: function(callback) {
    let url = config.serverUrl + 'tutoriallist'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  updateTutoriallist: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'tutoriallist', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getProductBundle: function(data, callback) {
    let url = config.serverUrl + 'productbundle?productid=' + data.id
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  saveProductBundle: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(config.serverUrl + 'productbundle?productid=' + data.productid, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  editProductBundle: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'productbundle?productbundleid=' + data.id, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  deleteProductBundle: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .delete(config.serverUrl + 'productbundle?productbundleid=' + data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getGbprime: function(data, callback) {
    let url = config.serverUrl + 'gbprime?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  saveGbprime: function(data, callback) {
    let url = config.serverUrl + 'gbprime?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getLineToken: function(data, callback) {
    let url = config.serverUrl + 'linetoken?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  saveLineToken: function(data, callback) {
    let url = config.serverUrl + 'linetoken?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  checkGBprimeToken: function(data) {
    return new Promise((resolve, reject) => {
      var request = {
        token: data.token,
        amount: '1',
        referenceNo: new Date().getTime(),
        payType: 'F',
        cardUse: 'Y',
        billUse: 'Y',
        qrUse: 'Y',
        expire: '1',
        deliveryMethod: '0',
        multipleUse: 'N',
        detail: 'Check Valid Token'
      }
      axios
        .post('https://api.gbprimepay.com/gbp/gateway/link', request)
        .then(response => {
          if (response.data.gbLinkUrl !== undefined) {
            resolve()
          } else {
            reject(new Error('Something wrong'))
          }
        })
        .catch(e => {
          reject(e)
        })
    })
  },

  getPublishedPost: function(fburl) {
    return new Promise((resolve, reject) => {
      let url = null
      if (fburl && fburl != '') {
        url = fburl
      } else {
        url =
          'https://graph.facebook.com/v3.2/' +
          store.state.selectedBot.pageid +
          '/posts?access_token=' +
          store.state.selectedBot.page_access_token
      }
      axios
        .get(url)
        .then(response => {
          response = response.data
          if (response) {
            resolve(response)
          } else {
            reject(new Error('Something went wrong'))
          }
        })
        .catch(e => {
          reject(e)
        })
    })
  },

  getSchedulePost: function(fburl) {
    return new Promise((resolve, reject) => {
      let url = null
      if (fburl && fburl != '') {
        url = fburl
      } else {
        url =
          'https://graph.facebook.com/v3.2/' +
          store.state.selectedBot.pageid +
          '/scheduled_posts?access_token=' +
          store.state.selectedBot.page_access_token
      }
      axios
        .get(url)
        .then(response => {
          response = response.data
          if (response) {
            resolve(response)
          } else {
            reject(new Error('Something went wrong'))
          }
        })
        .catch(e => {
          reject(e)
        })
    })
  },

  saveUserStatus: function(data, callback) {
    let url = config.serverUrl + 'userstatus?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getUserStatus: function(data, callback) {
    let url = config.serverUrl + 'userstatus?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  saveUserEmail: function(data, callback) {
    let url = config.serverUrl + 'useremail?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  saveUserPhoneno: function(data, callback) {
    let url = config.serverUrl + 'userphoneno?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  saveUserTags: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'usertags?pageid=' + data.pageid, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  saveUserProvince: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'userprovince?pageid=' + data.pageid, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  saveUserLineId: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'userlineid?pageid=' + data.pageid, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  saveUserSchool: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'userschool?pageid=' + data.pageid, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getWholesaleStatus: function(data, callback) {
    let url = config.serverUrl + 'wholesale_status?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  saveWholesaleStatus: function(data, callback) {
    let url = config.serverUrl + 'wholesale_status?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getWholesale: function(data, callback) {
    let url = config.serverUrl + 'wholesale?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  saveWholesale: function(data, callback) {
    let url = config.serverUrl + 'wholesale?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  editWholesale: function(data, callback) {
    let url = config.serverUrl + 'wholesale?wholesaleid=' + data.wholesaleid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  deleteWholesale: function(data, callback) {
    let url = config.serverUrl + 'wholesale?wholesaleid=' + data.wholesaleid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .delete(url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getPauseStatus: function(data, callback) {
    let url = config.serverUrl + 'notreplyduplicateintent?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  togglePauseStatus: function(data, callback) {
    let url = config.serverUrl + 'notreplyduplicateintent?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getReplyDelay: function(data, callback) {
    let url = config.serverUrl + 'replydelay?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  editReplyDelay: function(data, callback) {
    let url = config.serverUrl + 'replydelay?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getLineNotify: function(data, callback) {
    let url = config.serverUrl + 'linenotify?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  saveLineNotify: function(data, callback) {
    let url = config.serverUrl + 'linenotify'
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  deleteLineNotify: function(data, callback) {
    let url =
      config.serverUrl + 'linenotify?pageid=' + data['pageid'] + '&adminid=' + data['adminid']
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .delete(url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  saveLineNotifyNotification: function(data, callback) {
    let url = config.serverUrl + 'notifications?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getCompareIntents: function(data, callback) {
    let url =
      config.serverUrl + 'compareintents?pageid1=' + data.pageid1 + '&pageid2=' + data.pageid2
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getSupportUser: function(data, callback) {
    let url = config.serverUrl + 'supportusers?supportusers=' + data.supportusers
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  transferIntents: function(data, callback) {
    let url = config.serverUrl + 'cloneintents?pageid1=' + data.pageid1 + '&pageid2=' + data.pageid2

    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  saveSupportusers: function(data, callback) {
    let url = config.serverUrl + 'supportusers?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getAllShipingCharge: function(data, callback) {
    let url = config.serverUrl + 'allshipingcharge?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  saveAllShipingCharge: function(data, callback) {
    let url = config.serverUrl + 'allshipingcharge?pageid=' + data.pageid
    delete data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  insertUsersFromInbox: function(data, callback) {
    let url = config.serverUrl + 'insertusersfrominbox?pageid=' + data.pageid

    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getTimeToUseBot: function(data, callback) {
    let url = config.serverUrl + 'timetousebot?pageid=' + data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  saveTimeToUseBot: function(data, callback) {
    let url = config.serverUrl + 'timetousebot?pageid=' + data.pageid
    delete data.pageid
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(url, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getVideoList: function() {
    return new Promise((resolve, reject) => {
      let url =
        'https://graph.facebook.com/v4.0/' +
        store.state.selectedBot.pageid +
        '/video_lists?access_token=' +
        store.state.selectedBot.page_access_token
      axios
        .get(url)
        .then(response => {
          response = response.data
          if (response) {
            resolve(response)
          } else {
            reject(new Error('Something went wrong'))
          }
        })
        .catch(e => {
          reject(e)
        })
    })
  },

  getVideo: function() {
    return new Promise((resolve, reject) => {
      let url =
        'https://graph.facebook.com/v4.0/' +
        store.state.selectedBot.pageid +
        '/videos?access_token=' +
        store.state.selectedBot.page_access_token +
        '&fields=permalink_url,title,description,source,id,picture,length'
      axios
        .get(url)
        .then(response => {
          response = response.data
          if (response) {
            resolve(response)
          } else {
            reject(new Error('Something went wrong'))
          }
        })
        .catch(e => {
          reject(e)
        })
    })
  },

  getWordAfterOrderAndCartSummary: function(data, callback) {
    let url = config.serverUrl + 'wordsafterordersandcartsummary?pageid=' + data.pageid

    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  saveWordAfterOrderAndCartSummary: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'wordsafterordersandcartsummary?pageid=' + data.pageid, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getAstonAdminTasks: function(data, callback) {
    let url = config.serverUrl + 'astonadmintasks'

    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getAstonAdminTasksOutsource: function(data, callback) {
    let url = config.serverUrl + 'astonadmintasksoutsource'

    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getAstonAdminTasksLine: function(data, callback) {
    let url = config.serverUrl + 'astonadmintasksline'

    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getAstonTagOrderFromAds: function(data, callback) {
    let url = config.serverUrl + 'astontagorderfromads'

    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getAstonRefIdOrderDetail: function(data, callback) {
    let url = config.serverUrl + 'astonrefidorderdetail'

    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getAstonCloseTasksPerAdmin: function(data, callback) {
    let url = config.serverUrl + 'astonclosetasksperadmin'

    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getAstonCloseTasksPerAdminOutsource: function(data, callback) {
    let url = config.serverUrl + 'astonclosetasksperadminoutsource'

    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getAstonAdminUserDetails: function(data, callback) {
    let url = config.serverUrl + 'astonadminuserdetails'

    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getAstonAdminUserUserGroupByWord: function(data, callback) {
    let url = config.serverUrl + 'astonadminusergroupbyword'

    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getKetshopToken: function(data, callback) {
    let url = config.serverUrl + 'ketshop_shoptoken'

    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  saveKetshopToken: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(`${config.serverUrl}ketshop_shoptoken?pageid=${data.pageid}`, data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getUser: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = config.serverUrl + 'getuser'

    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: data })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  saveAstonUpdateAdminTasks: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'astonupdateadmintasks', data)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },

  getbudashboardregisterquestion: function(data, callback) {
    let url = config.serverUrl + 'budashboardregisterquestion'
    let params = data.start ? { dateFrom: data.start, dateTo: data.end } : {}
    Object.assign(params, { pageid: data.pageid })
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: params })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getbudashboardfaculty: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(
        config.serverUrl +
          `budashboardfaculty?dateFrom=${data.start}&dateTo=${data.end}&pageid=${data.pageid}`
      )
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getbudashboardscholarships: function(data, callback) {
    let url = config.serverUrl + 'budashboardscholarships'
    let params = data.start ? { dateFrom: data.start, dateTo: data.end } : {}
    Object.assign(params, { pageid: data.pageid })

    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(url, { params: params })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  putchangebotstate: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + 'changebotstate?pageid=' + data.pageid, data.input)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getschoollist: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + 'schoollist')
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  // multistatusordersummary?pageid=....&orderidlist=.....&statusorder=......
  putmultistatusordersummary: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(
        config.serverUrl +
          `multistatusordersummary?pageid=${data.pageid}&orderidlist=${data.orderid}&statusorder=${
            data.status
          }`,
        data.input
      )
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  putprioritycategories: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + `prioritycategories?pageid=${data.pageid}`, {
        categorieslist: data.input
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getcompareshopservice: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .get(config.serverUrl + `compareshopservice?pageid1=${data.pageid1}&pageid2=${data.pageid2}`)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  transfershopservice: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .post(
        config.serverUrl + `transfershopservice?pageid1=${data.pageid1}&pageid2=${data.pageid2}`,
        data
      )
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  saveUserContext: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    axios
      .put(config.serverUrl + `usercontext?pageid=${data.pageid}`, {
        context: data.context,
        userid: data.usersid
      })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  zwizadminbotlist: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `zwizadminbotlist?limit=${data.limit}&offset=${data.offset}`
    if (data.pagename) url += `&pagename=${data.pagename}`
    axios
      .get(config.serverUrl + url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getuserCustomer: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `getuser?pageid=${data.pageid}&userid=${data.userid}`
    axios
      .get(config.serverUrl + url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getInfocustomerspremium: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `infocustomerspremium?pageid=${data['pageid']}&type=${data.type}&package=${
      data.package
    }`
    axios
      .get(config.serverUrl + url)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  getImageChatlogs: function(params, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `imagechatlogs`
    axios
      .get(config.serverUrl + url, { params })
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  postInfocustomerspremium: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `infocustomerspremium?pageid=${data['pageid']}&package=${data.package}`
    axios
      .post(config.serverUrl + url, data.obj)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  collectlineidpremiumextra: function(data, callback) {
    axios.defaults.headers.common = {
      AUTHORIZATION: store.getters.securityToken
    }
    let url = `collectlineidpremiumextra?pageid=${data['pageid']}`
    axios
      .put(config.serverUrl + url, data.obj)
      .then(response => {
        this.defaultResponse(response, callback)
      })
      .catch(e => {
        this.defaultError(e, callback)
      })
  },
  // =============== default function =================

  defaultResponse: function(response, callback) {
    // store.dispatch('logout', { 'code': '400', 'message': 'Session expire. Please login again.'  }).then(function(){
    // 	router.push('/login')

    // })
    response = response.data
    if (response.responsecode === 200) {
      callback(null, response)
    } else if (response.responsecode === 400) {
      let message = response.reason ? response.reason : ''
      var isFacebook = store.state.isFacebook

      // console.log('before',isFacebook)
      store.dispatch('logout', { code: response.responsecode, message: message }).then(function() {
        // console.log('after', isFacebook)
        if (router.history.current.name !== 'login' || router.history.current.name !== 'nigol') {
          // console.log(router.history.current.name)
          if (isFacebook) {
            router.push('/' + store.getters.currentLang + '/login')
          } else {
            router.push('/' + store.getters.currentLang + '/nigol')
          }
        }

        callback(new Error('Session expire. Please login again.'))
      })
    } else {
      // console.log(response)
      if (response.reason) {
        callback(new Error(response.reason))
      } else {
      }
    }
  },

  defaultError: function(e, callback) {
    if (process.env.NODE_ENV !== 'production') {
      console.log(e)
    }
    callback(new Error('Session expire. Please login again.'))
  },

  joinFilter: function(data, isPremium) {
    var url = []
    if (data['gender']) {
      url.push('gender=' + data['gender'].value)
    }
    if (data['fullname']) {
      url.push('fullname=' + data['fullname'])
    }
    if (data['app']) {
      if (data['app'].value !== 'all') {
        url.push('app=' + data['app'].value)
      }
    }
    if (data['locale'] && data['locale'].length > 0) {
      var locales = []
      if (data['locale']) {
        data['locale'].map(function(locale, index) {
          locales.push(locale.value)
        })
      }
      url.push('locale=' + locales.join(','))
    }
    if (data['tags']) {
      url.push('tags=' + data['tags'])
    }
    if (data['activeDate']['start']) {
      url.push('timestamp_from=' + moment(data['activeDate']['start']).format('YYYY-MM-DD'))
    }
    if (data['activeDate']['end']) {
      url.push('timestamp_to=' + moment(data['activeDate']['end']).format('YYYY-MM-DD'))
    }
    if (data['registerDate']['start']) {
      url.push(
        'registertimestamp_from=' + moment(data['registerDate']['start']).format('YYYY-MM-DD')
      )
    }
    if (data['registerDate']['end']) {
      url.push('registertimestamp_to=' + moment(data['registerDate']['end']).format('YYYY-MM-DD'))
    }
    if (data['lineid']) {
      url.push('lineid=' + data['lineid'])
    }
    if (data['school']) {
      url.push('school=' + data['school'].name)
    }
    if (data['province']) {
      url.push('province=' + data['province'])
    }

    if (isPremium) {
      if (data['email']) {
        url.push('email=' + data['email'])
      }
      if (data['context']) {
        url.push('context=' + data['context'])
      }
      if (data['phoneno']) {
        url.push('phoneno=' + data['phoneno'])
      }
      if (data['status'] && data['status'].length > 0) {
        url.push('status=' + data['status'])
      }
      if (data['intent'] && data['intent'].length > 0) {
        url.push('intent=' + data['intent'].join(','))
      }
      if (data['timezone']['from'] || data['timezone']['to']) {
        var timezone = []
        if (data['timezone']['from']) {
          timezone.push(data['timezone']['from'])
        }
        if (data['timezone']['to']) {
          timezone.push(data['timezone']['to'])
        }
        url.push('timezone=' + timezone.join(','))
      }

      if (data['messagesent']['value'] != null && data['messagesent']['value'] !== '') {
        url.push('messagesent=' + data['messagesent']['symbol'] + data['messagesent']['value'])
      }
    }

    return url.join('&')
  }
}



// WEBPACK FOOTER //
// ./src/api/index.js